export default "__VITE_ASSET__hIQ5_dgQ__"